import { useMemo } from 'react';
import { useCorporateBondScreenerContext } from '@/creditflowresearch/application/CorporateBondScreener/CorporateBondScreenerContext';
import { DEFAULT_FILTERS, UI_ONLY_FILTER_KEYS } from '@/creditflowresearch/application/CorporateBondScreener/buildCorporateBondScreenerRequest';
import { countActiveFilters } from '@/creditflowresearch/application/BondScreener/countActiveFilters';

const useCorporateBondScreenerFiltersCount = (): number => {
  const { filterPayload } = useCorporateBondScreenerContext();

  return useMemo(
    () => countActiveFilters(filterPayload, DEFAULT_FILTERS, UI_ONLY_FILTER_KEYS),
    [filterPayload],
  );
};

export default useCorporateBondScreenerFiltersCount;
